/* TraderzLife tools: cinematic layer.
   Adds a 3D session dial, a risk ring and an unrolling equity chart on top of the
   three free tools. It only reads what the tools already compute or show; it never
   changes their maths. If a tool is missing, its part simply does nothing. */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  function el(tag, attrs, parent) {
    var n = document.createElementNS(NS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  function polar(cx, cy, r, deg) {
    var a = (deg - 90) * Math.PI / 180;
    return [cx + r * Math.cos(a), cy + r * Math.sin(a)];
  }
  function arc(cx, cy, r, h0, h1) {
    var span = ((h1 - h0) % 24 + 24) % 24 || 24;
    var a0 = h0 * 15, a1 = a0 + span * 15 - 0.001;
    var p0 = polar(cx, cy, r, a0), p1 = polar(cx, cy, r, a1);
    return 'M' + p0[0].toFixed(2) + ' ' + p0[1].toFixed(2) + ' A' + r + ' ' + r + ' 0 ' +
      (span > 12 ? 1 : 0) + ' 1 ' + p1[0].toFixed(2) + ' ' + p1[1].toFixed(2);
  }

  /* Gentle 3D tilt that follows the pointer. Mouse and trackpad only. */
  function tilt(node, max) {
    if (!fine || reduce || !node) return;
    node.classList.add('fx-tilt');
    node.addEventListener('pointermove', function (e) {
      var r = node.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      node.style.setProperty('--fx-ry', (x * max).toFixed(2) + 'deg');
      node.style.setProperty('--fx-rx', (-y * max).toFixed(2) + 'deg');
      node.style.setProperty('--fx-gx', ((x + 0.5) * 100).toFixed(1) + '%');
      node.style.setProperty('--fx-gy', ((y + 0.5) * 100).toFixed(1) + '%');
    });
    node.addEventListener('pointerleave', function () {
      node.style.setProperty('--fx-ry', '0deg'); node.style.setProperty('--fx-rx', '0deg');
    });
  }

  /* ================= Session clock: the dial ================= */
  function clockDial() {
    var root = document.querySelector('.tl-clock');
    if (!root || typeof SESSIONS === 'undefined' || typeof sessUTC !== 'function') return;
    var nowCard = root.querySelector('.card');
    if (!nowCard) return;
    var COL = { 'Sydney': '#3fc8ff', 'Tokyo': '#a28aff', 'London': '#d9b66b', 'New York': '#00e5a0' };
    var R = { 'Sydney': 156, 'Tokyo': 136, 'London': 116, 'New York': 96 };

    var card = document.createElement('div');
    card.className = 'card fx-dial-card';
    card.innerHTML =
      '<h2>The trading day as a dial</h2>' +
      '<div class="fx-dial-wrap"><div class="fx-dial-stage">' +
      '<svg class="fx-dial" viewBox="0 0 400 400" role="slider" tabindex="0" aria-valuemin="0" ' +
      'aria-valuemax="23" aria-label="Hour of the day in your timezone"></svg></div>' +
      '<div class="fx-dial-read" aria-live="polite"><div class="fx-dial-time"></div>' +
      '<div class="fx-dial-open"></div><div class="fx-dial-key"></div>' +
      '<p class="fx-dial-help">Point at or tap any hour on the dial, or focus it and use the arrow keys. ' +
      'Midnight is at the top; Esc returns to now.</p></div></div>';
    nowCard.parentNode.insertBefore(card, nowCard.nextSibling);

    var svg = card.querySelector('svg'), stage = card.querySelector('.fx-dial-stage');
    var tEl = card.querySelector('.fx-dial-time'), oEl = card.querySelector('.fx-dial-open');
    card.querySelector('.fx-dial-key').innerHTML = SESSIONS.map(function (s) {
      return '<span><i style="background:' + COL[s.name] + '"></i>' + s.name + '</span>';
    }).join('');

    var gArcs, needle, scrub, scrubDot, hover = null, lastKey = '';

    function offNow() { return tzOffsetHours(new Date(), TZ); }
    /* Each session's window in the viewer's local hours, for today. */
    function localWindows() {
      var now = new Date(), off = offNow();
      return SESSIONS.map(function (s) {
        var w = sessUTC(s, now);
        return { s: s, o: ((w.open + off) % 24 + 24) % 24, c: ((w.close + off) % 24 + 24) % 24 };
      });
    }
    function openAt(wins, h) {
      return wins.filter(function (w) {
        return w.o < w.c ? (h >= w.o && h < w.c) : (h >= w.o || h < w.c);
      });
    }
    function build() {
      svg.innerHTML = '';
      var defs = el('defs', {}, svg);
      var gl = el('filter', { id: 'fxglow', x: '-20%', y: '-20%', width: '140%', height: '140%' }, defs);
      el('feGaussianBlur', { stdDeviation: '4', result: 'b' }, gl);
      var m = el('feMerge', {}, gl); el('feMergeNode', { in: 'b' }, m); el('feMergeNode', { in: 'SourceGraphic' }, m);
      el('circle', { cx: 200, cy: 200, r: 190, class: 'fx-face' }, svg);
      for (var h = 0; h < 24; h++) {
        var a = polar(200, 200, 182, h * 15), b = polar(200, 200, h % 3 ? 177 : 172, h * 15);
        el('line', { x1: a[0], y1: a[1], x2: b[0], y2: b[1], class: h % 3 ? 'fx-tick' : 'fx-tick fx-tick-major' }, svg);
        if (h % 3 === 0) {
          var t = polar(200, 200, 196, h * 15);
          var tx = el('text', { x: t[0], y: t[1] + 3.5, class: 'fx-hour' }, svg); tx.textContent = pad(h);
        }
      }
      var wins = localWindows();
      gArcs = el('g', { class: 'fx-arcs' }, svg);
      wins.forEach(function (w) {
        el('circle', { cx: 200, cy: 200, r: R[w.s.name], class: 'fx-track' }, gArcs);
        el('path', { d: arc(200, 200, R[w.s.name], w.o, w.c), stroke: COL[w.s.name], class: 'fx-arc', filter: 'url(#fxglow)' }, gArcs);
      });
      /* Gold band where two or more centres overlap. */
      for (var q = 0; q < 96; q++) {
        var hh = q / 4 + 0.125;
        if (openAt(wins, hh).length > 1) el('path', { d: arc(200, 200, 168, q / 4, q / 4 + 0.25), class: 'fx-overlap' }, gArcs);
      }
      scrub = el('line', { x1: 200, y1: 200, x2: 200, y2: 30, class: 'fx-scrub' }, svg);
      scrubDot = el('circle', { cx: 200, cy: 30, r: 5, class: 'fx-scrub-dot' }, svg);
      needle = el('g', { class: 'fx-needle' }, svg);
      el('line', { x1: 200, y1: 200, x2: 200, y2: 26, class: 'fx-needle-line' }, needle);
      el('circle', { cx: 200, cy: 26, r: 5, class: 'fx-needle-tip' }, needle);
      el('circle', { cx: 200, cy: 200, r: 52, class: 'fx-hub' }, svg);
      el('circle', { cx: 200, cy: 200, r: 4, class: 'fx-pin' }, svg);
      lastKey = TZ + '|' + wins.map(function (w) { return w.o + '-' + w.c; }).join(',');
    }
    function nowLocalHour() {
      var p = partsIn(new Date(), TZ);
      return +p.hour + p.minute / 60 + p.second / 3600;
    }
    function fmt(h) { var m = Math.round(h * 60) % 1440; return pad(Math.floor(m / 60)) + ':' + pad(m % 60); }
    function update() {
      var wins = localWindows();
      var key = TZ + '|' + wins.map(function (w) { return w.o + '-' + w.c; }).join(',');
      if (key !== lastKey) build();
      var nh = nowLocalHour();
      needle.setAttribute('transform', 'rotate(' + (nh * 15).toFixed(2) + ' 200 200)');
      var weekend = typeof weekendClosed === 'function' && weekendClosed(new Date());
      svg.classList.toggle('fx-weekend', !!weekend && hover === null);
      paintClock(openAt(wins, nh), weekend);
      var h = hover === null ? nh : hover;
      var on = openAt(wins, h);
      scrub.style.display = scrubDot.style.display = hover === null ? 'none' : '';
      if (hover !== null) {
        var p = polar(200, 200, 182, hover * 15);
        scrub.setAttribute('x2', p[0]); scrub.setAttribute('y2', p[1]);
        scrubDot.setAttribute('cx', p[0]); scrubDot.setAttribute('cy', p[1]);
      }
      [].forEach.call(gArcs.querySelectorAll('.fx-arc'), function (a, i) {
        a.classList.toggle('fx-on', on.some(function (w) { return w.s === wins[i].s; }));
      });
      tEl.textContent = (hover === null ? 'Now, ' : 'At ') + fmt(h) + ' your time';
      var txt;
      if (hover === null && weekend) txt = 'Weekend. Spot FX is closed.';
      else if (!on.length) txt = 'No major centre open. Liquidity is at its thinnest.';
      else txt = on.map(function (w) { return w.s.name; }).join(' and ') + (on.length > 1 ? ' open together.' : ' open.');
      if (hover !== null && weekend) txt += ' (On a weekday.)';
      oEl.textContent = txt;
      svg.setAttribute('aria-valuenow', Math.floor(h));
      svg.setAttribute('aria-valuetext', fmt(h) + ': ' + txt);
    }
    /* The big digital clock takes the colour of whichever centres are open now:
       one centre gives its colour, an overlap blends them, none or weekend is grey. */
    var clockEl = document.getElementById('clock'), lastPaint = null;
    function paintClock(on, weekend) {
      if (!clockEl) return;
      var cols = weekend ? [] : on.map(function (w) { return COL[w.s.name]; });
      var key = cols.join(',');
      if (key === lastPaint) return;
      lastPaint = key;
      clockEl.classList.remove('fx-clock-one', 'fx-clock-many', 'fx-clock-none');
      clockEl.style.removeProperty('--fx-c1'); clockEl.style.removeProperty('--fx-grad');
      if (!cols.length) { clockEl.classList.add('fx-clock-none'); return; }
      if (cols.length === 1) { clockEl.classList.add('fx-clock-one'); clockEl.style.setProperty('--fx-c1', cols[0]); return; }
      clockEl.classList.add('fx-clock-many');
      clockEl.style.setProperty('--fx-c1', cols[0]);
      clockEl.style.setProperty('--fx-grad', 'linear-gradient(90deg,' + cols.join(',') + ')');
    }
    function hourFromEvent(e) {
      var r = svg.getBoundingClientRect();
      var x = e.clientX - (r.left + r.width / 2), y = e.clientY - (r.top + r.height / 2);
      var deg = (Math.atan2(y, x) * 180 / Math.PI + 90 + 360) % 360;
      return Math.round(deg / 15 * 4) / 4 % 24;
    }
    svg.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' && !e.buttons && e.pointerType !== 'pen') return;
      hover = hourFromEvent(e); update();
    });
    svg.addEventListener('pointerdown', function (e) {
      stage.classList.add('fx-flat'); svg.setPointerCapture && svg.setPointerCapture(e.pointerId);
      hover = hourFromEvent(e); update();
    });
    svg.addEventListener('pointerup', function () { stage.classList.remove('fx-flat'); });
    svg.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse') { hover = null; update(); }
    });
    svg.addEventListener('keydown', function (e) {
      var base = hover === null ? Math.floor(nowLocalHour()) : hover;
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') hover = (Math.floor(base) + 1) % 24;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') hover = (Math.ceil(base) + 23) % 24;
      else if (e.key === 'Escape' || e.key === 'Home') hover = null;
      else return;
      e.preventDefault(); update();
    });
    svg.addEventListener('blur', function () { hover = null; update(); });
    var tz = document.getElementById('tz');
    if (tz) tz.addEventListener('change', function () { build(); update(); });
    build(); update();
    setInterval(update, 1000);
  }

  /* ================= Position size calculator: the risk ring ================= */
  function num(s) {
    s = String(s || '').replace(/[^0-9.,-]/g, '');
    if (/,\d{1,2}$/.test(s)) s = s.replace(/\./g, '').replace(',', '.'); else s = s.replace(/,/g, '');
    var v = parseFloat(s); return isFinite(v) ? v : NaN;
  }
  function riskRing() {
    var root = document.querySelector('.tl-psc');
    if (!root) return;
    var out = root.querySelector('.out'), lots = document.getElementById('lots'), sub = document.getElementById('lotsub');
    if (!out || !lots || !sub) return;
    var wrap = document.createElement('div'); wrap.className = 'fx-ring';
    var svg = el('svg', { viewBox: '0 0 240 240', 'aria-hidden': 'true', class: 'fx-ring-svg' });
    var C1 = 2 * Math.PI * 104, C2 = 2 * Math.PI * 88;
    el('circle', { cx: 120, cy: 120, r: 104, class: 'fx-ring-track' }, svg);
    var a1 = el('circle', { cx: 120, cy: 120, r: 104, class: 'fx-ring-risk', 'stroke-dasharray': C1, 'stroke-dashoffset': C1, transform: 'rotate(-90 120 120)' }, svg);
    el('circle', { cx: 120, cy: 120, r: 88, class: 'fx-ring-track fx-ring-track-in' }, svg);
    var a2 = el('circle', { cx: 120, cy: 120, r: 88, class: 'fx-ring-margin', 'stroke-dasharray': C2, 'stroke-dashoffset': C2, transform: 'rotate(-90 120 120)' }, svg);
    var mid = document.createElement('div'); mid.className = 'fx-ring-mid';
    lots.parentNode.insertBefore(wrap, lots);
    wrap.appendChild(svg); wrap.appendChild(mid); mid.appendChild(lots); mid.appendChild(sub);
    var legend = document.createElement('div'); legend.className = 'fx-ring-legend';
    wrap.parentNode.insertBefore(legend, wrap.nextSibling);
    function update() {
      var bad = lots.classList.contains('bad');
      var loss = num(document.getElementById('oLoss').textContent);
      var risk = num(document.getElementById('oRisk').textContent);
      var mtxt = document.getElementById('oMargin').textContent;
      var mm = mtxt.match(/\(([\d.,]+)%\)/), mpct = mm ? num(mm[1]) : NaN;
      var cap = num((document.getElementById('maxMargin') || {}).value);
      var rShare = bad || !(risk > 0) || isNaN(loss) ? 0 : Math.min(1, loss / risk);
      var mShare = bad || isNaN(mpct) || !(cap > 0) ? 0 : Math.min(1, mpct / cap);
      a1.setAttribute('stroke-dashoffset', (C1 * (1 - rShare)).toFixed(1));
      a2.setAttribute('stroke-dashoffset', (C2 * (1 - mShare)).toFixed(1));
      wrap.classList.toggle('fx-bad', bad);
      wrap.classList.toggle('fx-capped', /capped/.test(sub.textContent));
      var html = bad ? '<span class="fx-k fx-k-bad"></span>No position at these settings.' :
        '<span class="fx-k fx-k-risk"></span>Outer ring: the loss if stopped, as a share of the risk you set (' +
        Math.round(rShare * 100) + '%).<br><span class="fx-k fx-k-margin"></span>Inner ring: margin used, as a share of your ' +
        (isNaN(cap) ? '' : cap + '% ') + 'margin limit' + (isNaN(mpct) ? ' (not checked).' : ' (' + Math.round(mShare * 100) + '%).');
      if (legend.innerHTML !== html) legend.innerHTML = html;   // no change, no new mutation
    }
    new MutationObserver(update).observe(out, { childList: true, characterData: true, subtree: true });
    update();
    tilt(out, 7);
  }

  /* ================= Risk of ruin: unrolling paths and a scrubber ================= */
  function ruinStage() {
    var root = document.querySelector('.tl-ror');
    if (!root) return;
    var g = document.getElementById('pathG'), card = root.querySelector('.paths');
    if (!g || !card) return;
    var svg = g.ownerSVGElement;
    var stage = document.createElement('div'); stage.className = 'fx-stage';
    svg.parentNode.insertBefore(stage, svg); stage.appendChild(svg);
    var clip = el('clipPath', { id: 'fxunroll' });
    var defs = svg.querySelector('defs') || el('defs', {}, svg); defs.appendChild(clip);
    var rect = el('rect', { x: 0, y: -10, width: reduce ? 1000 : 0, height: 320 }, clip);
    g.setAttribute('clip-path', 'url(#fxunroll)');
    var line = el('line', { x1: 0, x2: 0, y1: 0, y2: 300, class: 'fx-scan', 'vector-effect': 'non-scaling-stroke' }, svg);
    var tip = document.createElement('div'); tip.className = 'fx-tip'; tip.setAttribute('aria-live', 'polite');
    stage.appendChild(tip);
    var anim = 0;
    function unroll() {
      if (reduce) { rect.setAttribute('width', 1000); return; }
      cancelAnimationFrame(anim);
      var t0 = performance.now();
      (function step(t) {
        var k = Math.min(1, (t - t0) / 900), e = 1 - Math.pow(1 - k, 3);
        rect.setAttribute('width', (1000 * e).toFixed(1));
        if (k < 1) anim = requestAnimationFrame(step);
      })(t0);
    }
    function ruinXs() {
      return [].map.call(g.querySelectorAll('path'), function (p) {
        if ((p.getAttribute('stroke') || '').toLowerCase() !== '#ff4d6d') return null;
        var m = (p.getAttribute('d') || '').match(/([\d.]+) [\d.]+\s*$/);
        return m ? +m[1] : null;
      }).filter(function (x) { return x !== null; });
    }
    var horizon = function () { var h = document.getElementById('horizon'); return h ? +h.value : 200; };
    function show(e) {
      var r = svg.getBoundingClientRect();
      var fx = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)), x = fx * 1000;
      var xs = ruinXs(), n = Math.round(fx * horizon());
      var gone = xs.filter(function (v) { return v <= x + 0.5; }).length;
      var total = g.querySelectorAll('path').length - 1;
      line.setAttribute('x1', x); line.setAttribute('x2', x); line.style.opacity = 1;
      tip.style.left = (fx * 100) + '%';
      tip.classList.toggle('fx-tip-left', fx > 0.7);
      tip.style.opacity = 1;
      tip.textContent = 'By trade ' + n + ': ' + gone + ' of ' + Math.max(total, 0) + ' sample paths ruined';
    }
    stage.addEventListener('pointermove', show);
    stage.addEventListener('pointerdown', show);
    stage.addEventListener('pointerleave', function () { line.style.opacity = 0; tip.style.opacity = 0; });
    new MutationObserver(unroll).observe(g, { childList: true });
    unroll();
    /* The verdict glows in whatever colour the tool chose for the result. */
    var v = document.getElementById('verdict'), rp = document.getElementById('ruinPct');
    if (v && rp) {
      var sync = function () { v.style.setProperty('--fx-verdict', rp.style.color || '#d9b66b'); };
      new MutationObserver(sync).observe(rp, { attributes: true, attributeFilter: ['style'] });
      sync(); tilt(v, 5);
    }
  }

  function start() {
    [clockDial, riskRing, ruinStage].forEach(function (f) {
      try { f(); } catch (err) { if (window.console) console.warn('tl-tools-fx', err); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
